import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  Button,
  Form,
  Input,
  Modal,
  Menu,
  Select,
  Row,
  Col,
  Checkbox,
} from "antd";
import {
  DownArrowDraw,
  HaberForm,
  FilteredGrid,
  FilterComp,
} from "../../Pages/styledElements";
import { DateRangePicker } from "react-date-range";
import Iconmoon from "../../Components/IconsFiles/icon";
import moment from "moment";
import SearchIcon from "../../Assets/Icons/search.svg";
import {
  getAllGrades,
  getGradeQualities,
} from "../../Services/settingsServices";
import { MultiSelect } from "react-multi-select-component";
import { getProductsData } from "../../Services/productServices";
import { getCountries, getCustomers } from "../../Services/customerServices";
import { paperMachineListData } from "../../Services/machineServices";
import { getMachineGradeSelectForConfig } from "../../Services/settingsServices.js";
import { getUnitData } from "../../Services/measurementService";

const MultiSelectHeader = styled.div`
  .dropdown-content {
    max-height: 100px;
  }
  .rmsc .options {
    max-height: 125px;
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
  }
  .rmsc .dropdown-heading .dropdown-heading-value {
    color: #000 ;
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 30px !important;
    height : 35px;
  }
  .rmsc .dropdown-heading {
    height : 35px;
    }

  .rmsc .dropdown-container {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
  }
`;

const { Option } = Select;

const SearchBarHeader = styled.div`
  .dropdown-content {
    max-height: 100px !important;
  }
  .searchBoxWrap {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    width: 100%;
  }
  .searchWidth {
    width: 41%;
    .ant-row {
      margin: 0;
    }
    .ant-col {
      input[type="text"] {
        padding-left: 15px !important;
      }
    }
    .searchIcon {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
        right: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${SearchIcon});
      }
    }
  }
  .filterParent {
    display: flex;
    position: relative;
    margin-right: auto;
    margin-left: 30px;

    .filterBtn {
      min-width: 90px;
      border: none;
      background-color: transparent;
      text-align: center;
      align-self: center;
      outline: none;
      svg {
        position: relative;
        top: 2px;
      }
      span {
        font-size: 15px;
        font-family: var(--sf-pro-display-m);
        color: #605e5c;
        padding-left: 7px;
      }
    }
  }
  .exportDataBtn {
    align-self: center;
    button {
      &:last-child {
        margin-right: 0px;
      }
      svg {
        top: 3px;
      }
    }
  }
`;
const OrderFilter = (props) => {
  const selectedGsmOptions=useRef('equal_to')
  // selectedGsmOptions.current='equal_to'
  const [appliedFiltersArray, setAppliedFiltersArray] = useState();
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const [sizeFilterForm] = Form.useForm();
  const [disableFilter, setDisableFilter] = useState(true);
  const [filterType, setFilterType] = useState(props.filterType);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [dateSelectionRange, setDateSelectionRange] = useState({
    startDate: new Date(),
    endDate: null,
    key: "selection",
  });
  const [grades, setGrades] = useState([]);
  const [searchedGrades, setSearchedGrades] = useState([]);
  const [qualities, setQualities] = useState([]);
  const [searchedQualities, setSearchedQualties] = useState([]);
  const [showQualities, setShowQualities] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState();
  const [selectedQualities, setSelectedQualities] = useState();
  const [checkAllQualities, setCheckAllQualities] = useState(false);
  const [qualityIndeterminate, setQualityIndeterminate] = useState(false);
  const [filterBtnDisable, setFilterBtnDisable] = useState(false);
  const filterRef = useRef();
  const [selectedGradeQualities, setSelectedGradeQualtites] = useState([]);
  const [checkAllStates, setCheckAllStates] = useState(false);
  const [gsmFilterType, setGsmFilterType] = useState('equal_to');
  const [selectedStates, setSelectedStates] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [countries, setCountries] = useState([]);
  const [machines, setMachines] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [jobCardForm] = Form.useForm();
  const [unitData,setUnitData] = useState(props?.unitData);
  const [orderTypesData, setOrderTypesData] = useState(props?.orderTypesData);
  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Disabled", label: "Disabled" },
  ];
  const gsmFilterOptions = [
    { label: "Equal to", value: "equal_to" },
    { label: "Less than", value: "less_than" },
    { label: "Greater than", value: "greater_than" },
    { label: "In Range", value: "in_range" },
  ];

  const multiSelectEnum = {
    status: { options: statusOptions },
    country: { options: countries },
    shift: {
      options: [
        { value: "1st", label: "1st" },
        { value: "2nd", label: "2nd" },
        { value: "3rd", label: "3rd" },
      ],
    },
    statusOpen: {
      options: [
        { value: "open", label: "open" },
        { value: "closed", label: "closed" },
      ],
    },
    orderStatus: {
      options: [
        { value: "Open", label: "Open" },
        { value: "Pending", label: "Pending" },
        { value: "Changes Requested", label: "Changes Requested" },
        { value: "Approved", label: "Approved" },
        { value: "Rejected", label: "Rejected" },
        { value: "On Hold", label: "On Hold" },
      ],
    },
    machine: { options: machines },
    order_type: {
      options: [
        { value: "Reel", label: "Reel" },
        { value: "Sheet", label: "Sheet" },
      ],
    },
    ply_type: {
      options: [
        { label: "Single Ply", value: 1 },
        { label: "Double Ply", value: 2 },
        { label: "3-Ply", value: 3 },
        { label: "4-Ply", value: 4 },
      ],
    },
    deckle_order_type: {
      options: [
        { value: "Unplanned Orders", label: "Unplanned Orders" },
        { value: "Planned Orders", label: "Planned Orders" },
      ],
    },
    customer: { options: customers },
    consignee: { options: customers },
    product: { options: products },
    priority: {
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    productionStatus: {
      options: [
        { value: "Open", label: "Open" },
        { value: "Produced", label: "Produced" },
        { value: "Rejected", label: "Rejected" },
        { value: "Cancelled", label: "Cancelled" },
      ],
    },
    role: {
      options: [
        { value: "Basic", label: "Basic" },
        { value: "Admin", label: "Admin" },
      ],
    },
    jc_status: {
      options: props.jobcardStatus
    },
  };

  const equalFilterOption = [{ label: "Equal to", value: "equal_to" }];
  const sizeTypeOptions = [
    { label: "Width", value: "width" },
    { label: "Length", value: "length" },
    { label: "Both", value: "both" },
  ];
  const [mousePos, setMousePos] = useState("left");

  useEffect(() => {

    return () => {
      window.removeEventListener(
        'click',
        handleMouseMove
      );
    };
  }, []);

  const handleMouseMove = (event) => {
    let midScreen = event.currentTarget.innerWidth/2;
    
    if(event.clientX <= midScreen)
    {
      setMousePos("left");
      window.removeEventListener(
        'click',
        handleMouseMove
      );
    }
    else{
      setMousePos("right");
      window.removeEventListener(
        'click',
        handleMouseMove
      );
    }
  
  };

  const handleClickOutside = (e) => {
    if (
      e.target.innerText !== "Equal to" &&
      e.target.innerText !== "Less than" &&
      e.target.innerText !== "Greater than" &&
      e.target.innerText !== "In Range" &&
      e.target.innerText !== "Width" &&
      e.target.innerText !== "Length" &&
      e.target.innerText !== "Both" &&
      !(unitData?.units_management?.length.data.filter(( name ) => name === e.target.innerText).length) &&
      !(unitData?.units_management?.weight.data.filter(( name ) => name === e.target.innerText).length) &&
      !(unitData?.units_management?.currency.data.filter(( name ) => name === e.target.innerText).length) &&
      !filterRef?.current?.contains(e.target)
    ) {
      setShowFilterOptions(false);
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      //jobCardForm.resetFields();
       setGsmFilterType('equal_to');
       selectedGsmOptions.current = 'equal_to';
      //setFilterType();
      setFilterBtnDisable(false);
      setFilterBtnDisable(false);
      closeFilterDetails();
      setShowFilterOptions(false);
      setDisableFilter(true);
      setQualities([]);
      setShowQualities(false);
      setSelectedGrade();
      setSelectedQualities([]);
      //clearFilters();
      setAppliedFiltersArray();
      filterForm.resetFields();
      sizeFilterForm.resetFields();
      setSelectedGradeQualtites([]);
      setCheckAllQualities(false);
      setSelectedQualities([]);
      //jobCardForm.resetFields();
      //setIndeterminate(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  useEffect(() => {
    if(filterType.value == 'grade_quality')
      getAllGrades().then((resp) => {
        // console.log("Grades", resp);
        setSearchedGrades(resp);
        setGrades(resp);
      });
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    (async() => {
      if(!props?.unitData)
      {
        getUnitData().then((response) => {
            setUnitData(response.data);
          })
          .catch((error) => {
            console.log(error);
        });
      }
      if(!props?.orderTypesData)
      {
        const resp = await getMachineGradeSelectForConfig();
          if (!resp.error) {
            let data = resp?.data?.data?.settings?.order_types;
            const filteredOrderTypes = data?.filter(item => item.value === true && (item.name === "reel" || item.name === "sheet"))
            .map(item => ({ name: item.name, value: item.value })); 
            setOrderTypesData(filteredOrderTypes);
        }
      }
    })();
    return () => {
      controller.abort();
    }
  }, []);

  useEffect(() => {
    if (selectedGrade) {
      if (selectedQualities && selectedQualities.length && !checkAllQualities) {
        const newGradeFilter = {
          grade: selectedGrade,
          qualities: selectedQualities,
        };
        const tempObj = {
          type: "grade_quality",
          grades: [newGradeFilter],
        };
        setSelectedGradeQualtites(tempObj.grades);
        // console.log("obj", tempObj);
        setAppliedFiltersArray(tempObj);
        setDisableFilter(false);
      } else {
        if (checkAllQualities) {
          const newGradeFilter = {
            grade: selectedGrade,
            qualities: [],
          };
          const tempObj = {
            type: "grade_quality",
            grades: [newGradeFilter],
          };
          setSelectedGradeQualtites(tempObj.grades);
          // console.log("obj", tempObj);
          setAppliedFiltersArray(tempObj);
          setDisableFilter(false);
        } else {
          setDisableFilter(true);
        }
      }
    } else {
      setDisableFilter(true);
    }
  }, [selectedQualities]);

  useEffect(() => {
    if(filterType.value == 'country')
    getCountries().then((resp) => {
      // console.log("Countries", resp);
      setCountries(
        resp.data.data.map((item) => {
          return { value: item, label: item };
        })
      );
    });
  }, []);

  useEffect(() => {
    if(filterType.value == 'machine')
    paperMachineListData().then((resp) => {
      // console.log("Machines", resp);
      setMachines(
        resp.map((item) => {
          return { value: item.code, label: item.code };
        })
      );
    });
  }, []);

  useEffect(() => {
    if(filterType.value == 'customer' || filterType.value == 'consignee')
    getCustomers().then((resp) => {
      // console.log("Customers", resp.map((item) => item.name));
      setCustomers(
        resp.map((item) => {
          return { value: item.name, label: item.name };
        })
      );
    });
  }, []);

  useEffect(() => {
   if( filterType.value == 'product')
    getProductsData().then((resp) => {
      // console.log("Customers", resp.map((item) => item.name));
      setProducts(
        resp.map((item) => {
          return { value: item.code, label: item.code };
        })
      );
    });
  }, []);

  useEffect(() => {
    if (selectedStates.length) {
      switch (filterType.value) {
        case "country":
          const countryFilter = {
            type: filterType.value,
            country: selectedStates,
          };
          setAppliedFiltersArray(countryFilter);
          break;
        case "status":
          const status =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Active"
              ? "active"
              : "disabled";
          const statusFilter = { type: filterType.value, status };
          setAppliedFiltersArray(statusFilter);
          break;
        case "shift":
          const shiftFilter = {
            type: filterType.value,
            shifts: selectedStates,
          };
          setAppliedFiltersArray(shiftFilter);
          break;
        case "statusOpen":
          const openClosedFilter = { type: "status", status: selectedStates };
          setAppliedFiltersArray(openClosedFilter);
          break;
        case "machine":
          const machineFilter = {
            type: filterType.value,
            machines: selectedStates,
          };
          setAppliedFiltersArray(machineFilter);
          break;
        case "order_type":
          const order_type =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Reel"
              ? "reel"
              : "sheet";
          const orderTypeFilter = { type: filterType.value, order_type };
          setAppliedFiltersArray(orderTypeFilter);
          break;
          case "ply_type":
          const plyTypeFilter = { 
            type: filterType.value, 
            plyTypes: selectedStates
          };
          setAppliedFiltersArray(plyTypeFilter);
          break;
        case "deckle_order_type":
          const deckle_order_type = 
          selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Unplanned Orders"
              ? "incomplete_orders"
              : "planned_orders";
          const deckleOrderTypeFilter = { type: filterType.value, deckle_order_type };
          setAppliedFiltersArray(deckleOrderTypeFilter);
          break;
        case "orderStatus":
          const orderStatusFilter = {
            type: "status",
            status: selectedStates.map((item) =>
              item === "Open"
                ? "open"
                : item === "Pending"
                ? "pending"
                : item === "Changes Requested"
                ? "review"
                : item === "Approved"
                ? "approved"
                : item === "Rejected"
                ? "rejected"
                : item === "On Hold"
                ? "hold"
                : null
            ),
          };
          setAppliedFiltersArray(orderStatusFilter);
          break;
        case "customer":
          const customerFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(customerFilter);
          break;
        case "consignee":
          const consigneFilter = {
            type: filterType.value,
            names: selectedStates,
          };
          setAppliedFiltersArray(consigneFilter);
          break;
        case "priority":
          const priority =
            selectedStates.length > 1
              ? "both"
              : selectedStates[0] === "Yes"
              ? "yes"
              : "no";
          const priorityFilter = { type: filterType.value, priority: priority };
          setAppliedFiltersArray(priorityFilter);
          break;
        case "role":
          const role =
            selectedStates.length > 1
              ? "BOTH"
              : selectedStates[0] === "Basic"
              ? "BASIC"
              : "ADMIN";
          const roleFilter = { type: filterType.value, role };
          setAppliedFiltersArray(roleFilter);
          break;
          case "jc_status":
          const jc_status = {
            type: filterType.value,
            status: selectedStates,
          };
          setAppliedFiltersArray(jc_status);
          break;
      }
      setDisableFilter(false);
    } else setDisableFilter(true);
  }, [selectedStates]);
  
  const openQualitiesHandler = (currentGrade) => {
    setSelectedGrade(currentGrade.name);
    // setShowQualities(true);
    getGradeQualities(currentGrade.name).then((resp) => {
      setQualities(resp.map((quality) => quality.name));
      setSearchedQualties(resp.map((quality) => quality.name));
      setShowQualities(true);
      if (resp.length === 0) {
        setDisableFilter(true);
      } else setDisableFilter(true);
    });
  };

  const searchGradeHandler = (e) => {
    if (e.target.value === "") {
      setSearchedGrades(grades);
    } else {
      setSearchedGrades(
        grades.filter((item) =>
          item.name.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const searchQualitiesHandler = (e) => {
    if (e.target.value === "") {
      setSearchedQualties(qualities);
    } else {
      setSearchedQualties(
        qualities.filter((item) =>
          item.toLowerCase().includes(e.target.value.toLowerCase())
        )
      );
    }
  };

  const selectAllQualitiesHandler = (e) => {
    setCheckAllQualities(!checkAllQualities);
    // setSelectedQualities(e.target.checked ? qualities : []);
    setQualityIndeterminate(false);
    if (e.target.checked)
    {
      setDisableFilter(false);
      setSelectedQualities(qualities);
    }
    else {
      if (selectedQualities?.length)
        setDisableFilter(false);
      else
        setDisableFilter(true);
        setSelectedQualities([]);
    }
    
  };

  const checkQualityHandler = (e) => {
    setSelectedQualities(e);
    setCheckAllStates(e.length === qualities.length);
    setCheckAllQualities(e.length === qualities.length);
    //setIndeterminate(e.length && e.length < qualities.length);
  };

  const onFieldsChange = (values, allValues) => {
    allValues.map((item) => {
      if (item.errors.length) {
        setDisableFilter(true);
        return;
      } else setDisableFilter(false);
    });
  };

  const checkBoxOptionHandler = (e) => {
    setSelectedOption(e);
    let updatedSelectedOption = [];
    for (let index = 0; index < e.length; index++) {
      const element = e[index];
      updatedSelectedOption.push(element.value);
    }
    setSelectedStates(updatedSelectedOption);
    setCheckAllStates(
      e.length === multiSelectEnum[filterType.value].options.length
    );
    setIndeterminate(
      e.length && e.length < multiSelectEnum[filterType.value].options.length
    );
  };

  
  const renderSwitch = (type) => {
    switch (type) {
      case "date":
        return (
          <div className="dateRanged">
            <h6 className="filterTitle">
              {/* <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "} */}
              Filter by {filterType.name}
            </h6>
            <DateRangePicker
              ranges={[dateSelectionRange]}
              onChange={handleDateSelect}
            />
          </div>
        );
      case "grade":
        return (
          <div className="gradeFiltered scrolled-ui">
            <h6 className="filterTitle">
              {/* <Button className="backfilter" onClick={backFilter}>
                <span></span>
              </Button>{" "} */}
              Filter by {filterType.name}
            </h6>
            <Input
              placeholder="Search Grade"
              className="searchFilt"
              onChange={searchGradeHandler}
            />
            <Menu
              selectedKeys={[]}
              //onClick={filterSelect}
            >
              {searchedGrades.map((item) => (
                <Menu.Item
                  onClick={() => openQualitiesHandler(item)}
                  key={item.key}
                >
                  {item.name} <span className="arrowSel"></span>
                </Menu.Item>
              ))}
            </Menu>
            <div
              className={`qualityDroped ${
                // showQualities && qualities?.length ? "qualityEnabled" : ""
                showQualities ? "qualityEnabled" : ""
              }`}
            >
              <div className="gradeFiltered scrolled-ui">
                <h6 className="filterTitle">Select Qualites</h6>
                <Input
                  placeholder="Search Quality"
                  className="searchFilt"
                  onChange={searchQualitiesHandler}
                />
                <Menu selectedKeys={[]}>
                  <HaberForm>
                    {qualities?.length ? (
                      <Form>
                        <div className="all-Qul">
                          <Form.Item
                            name="chkAllProducts"
                            valuePropName=""
                            wrapperCol={{ span: 24 }}
                            className="alignedBox"
                          >
                            <Checkbox
                              indeterminate={qualityIndeterminate}
                              onChange={selectAllQualitiesHandler}
                              checked={checkAllQualities}
                            >
                              Select All products for this grade
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <label className="allQuality">
                          Select specific qualities
                        </label>
                        <div class="checkboxFilt">
                          <Checkbox.Group
                            options={searchedQualities}
                            value={selectedQualities}
                            onChange={checkQualityHandler}
                          />
                        </div>
                      </Form>
                    ) : (
                      <Form>
                        <div className="all-Qul">
                          <Form.Item
                            name=""
                            valuePropName=""
                            wrapperCol={{ span: 24 }}
                            className="alignedBox"
                          >
                            <Checkbox
                              indeterminate={qualityIndeterminate}
                              onChange={selectAllQualitiesHandler}
                              checked={checkAllQualities}
                            >
                              Select All products for this grade
                            </Checkbox>
                          </Form.Item>
                        </div>
                        <label
                          className="allQuality"
                          style={{ paddingTop: "12px" }}
                        >
                          No qualities for this grade
                        </label>
                      </Form>
                    )}
                  </HaberForm>
                </Menu>
              </div>
            </div>
          </div>
        );
        case "inputSelect":
          return (
            <HaberForm className="filterForm filterRanged">
              <h6 className="filterTitle">
                {/* <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "} */}
                Filter by {filterType.name}
              </h6>
              <Form
                form={filterForm}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFieldsChange={onFieldsChange}
              >
                <Form.Item
                  name="gsmFilterType"
                  className=""
                  rules={[
                    {
                      required: type === "inputSelect",
                      message: "This field is required",
                    },
                  ]}
                  initialValue={gsmFilterOptions[0]?.value}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    onChange={(e) => {
                      console.log("Event", e);
                      setGsmFilterType(e);
                      selectedGsmOptions.current = e;
                    }}
                    className={filterType.value}
                    placeholder="Select Range"
                  >
                    {gsmFilterOptions.map((item) => (
                      <Option key={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                {selectedGsmOptions.current === "in_range" ? (
                  <Row span={24} gutter={8}>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMin"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "inputSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input
                          placeholder={`Min. ${filterType.value}`}
                          style={{ paddingLeft: "10px !important" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMax"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "inputSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input
                          placeholder={`Max. ${filterType.value}`}
                          style={{ paddingLeft: "10px !important" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Form.Item
                    name="gsmFilterValue"
                    className="removepadd"
                    rules={[
                      {
                        required: type === "inputSelect",
                        message: "This field is required",
                      },
                      {
                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                        message: "Only numerical values are allowed",
                      },
                    ]}
                  >
                    <Input
                      placeholder={`Enter ${filterType.value}`}
                      style={{ paddingLeft: "10px !important" }}
                    />
                  </Form.Item>
                )}
              </Form>
            </HaberForm>
          );
       case "equalInputSelect":
          return (
            <HaberForm className="filterForm filterRanged">
              <h6 className="filterTitle">
                {/* <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "} */}
                Filter by {filterType.value}
              </h6>
              <Form
                form={filterForm}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFieldsChange={onFieldsChange}
              >
                <Form.Item
                  name="gsmFilterType"
                  className=""
                  rules={[
                    {
                      required: type === "equalInputSelect",
                      message: "This field is required",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    onChange={(e) => {
                      console.log("Event", e);
                      setGsmFilterType(e);
                      selectedGsmOptions.current = e;
                    }}
                    className={filterType.value}
                    placeholder="Select Range"
                  >
                    {equalFilterOption.map((item) => (
                      <Option key={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                {selectedGsmOptions.current === "in_range" ? (
                  <Row span={24} gutter={8}>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMin"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "equalInputSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input
                          placeholder={`Min. ${filterType.value}`}
                          style={{ paddingLeft: "10px !important" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMax"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "equalInputSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input
                          placeholder={`Max. ${filterType.value}`}
                          style={{ paddingLeft: "10px !important" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Form.Item
                    name="gsmFilterValue"
                    className="removepadd"
                    rules={[
                      {
                        required: type === "equalInputSelect",
                        message: "This field is required",
                      },
                      {
                        pattern: new RegExp(/^\d+(\.\d+)?$/),
                        message: "Only numerical values are allowed",
                      },
                    ]}
                  >
                    <Input
                      placeholder={`Enter ${filterType.value}`}
                      style={{ paddingLeft: "10px !important" }}
                    />
                  </Form.Item>
                )}
              </Form>
            </HaberForm>
          );

        case "multiSelect":
          return (
            <HaberForm style={{ width: "100%" }}>
              <h6 className="filterTitle">
                {/* <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "} */}
                {filterType.label}
              </h6>
              {/* <Input
                placeholder={`Search ${
                  filterType.label.split("by")[1] ||
                  filterType.label.spit("By")[1]
                }`}
                className="searchFilt"
                onChange={searchMultiSelectHandler}
              /> */}
              <Form>
                <div
                  className="filterSelectList checkboxFilt"
                  style={{ display: "flex", flexDirection: "column", margin : "10px" }}
                >
                  {/* <Checkbox
                    indeterminate={indeterminate}
                    onChange={selectAllHandler}
                    checked={checkAllStates}
                  >
                    Select all
                  </Checkbox>
                  <Checkbox.Group
                    options={
                      multiSelectSearch.bool
                        ? multiSelectSearch.searchedOptions
                        : multiSelectEnum[filterType.value].options
                    }
                    value={selectedStates}
                    onChange={(e)=>checkBoxOptionHandler(e)}
                  />
                 */}
                  <MultiSelectHeader>
                    <MultiSelect
                      options={multiSelectEnum[filterType.value].options}
                      value={selectedOption}
                      onChange={checkBoxOptionHandler}
                      valueRenderer={(selected) => {
                        if (!selected.length)
                          return `Search ${
                            filterType.label.split("by")[1] ||
                            filterType.label.spit("By")[1]
                          }`;
                      }}
                    />
                  </MultiSelectHeader>
                </div>
              </Form>
            </HaberForm>
          );
        case "rangeTypeSelect":
          return (
            <HaberForm className="filterForm filterRanged">
              <h6 className="filterTitle">
                {/* <Button className="backfilter" onClick={backFilter}>
                  <span></span>
                </Button>{" "} */}
                Filter by {filterType.name}
              </h6>
              <Form
                form={sizeFilterForm}
                name="basic"
                autoComplete="off"
                className="haberLogin"
                onFieldsChange={onFieldsChange}
              >
                <Form.Item
                  name="gsmFilterType"
                  className=""
                  rules={[
                    {
                      required: type === "rangeTypeSelect",
                      message: "This field is required",
                    },
                  ]}
                  initialValue={gsmFilterOptions[0]?.value}

                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    onChange={(e) => {
                      console.log("Event", e);
                      setGsmFilterType(e);
                      selectedGsmOptions.current = e;

                    }}
                    placeholder="Select Range"
                    className={filterType.value}
                  >
                    {gsmFilterOptions.map((item) => (
                      <Option key={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                </Form.Item>
                {!(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") &&
                (<Form.Item
                  name="sizeType"
                  className="removepadd"
                  rules={[
                    {
                      required: type === "rangeTypeSelect",
                      message: "This field is required",
                    },
                  ]}
                >
                  <Select
                    suffixIcon={<DownArrowDraw />}
                    placeholder="Select size type"
                    // onChange={(e) => {
                    //   console.log("Event", e);
                    //   setGsmFilterType(e);
                    // }}
                  >
                    {sizeTypeOptions.map((item) => (
                      <Option key={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                </Form.Item>)}
                {selectedGsmOptions.current === "in_range" ? (
                  <Row span={24} gutter={8}>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMin"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "rangeTypeSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input placeholder={`Min. ${filterType.value}`} />
                      </Form.Item>
                    </Col>
                    <Col span={12} className="d-flex">
                      <Form.Item
                        name="gsmMax"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "rangeTypeSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input placeholder={`Max. ${filterType.value}`} />
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  // <Form.Item
                  //   name="gsmFilterValue"
                  //   className="removepadd"
                  //   rules={[
                  //     {
                  //       required: type === "rangeTypeSelect",
                  //       message: "This field is required",
                  //     },
                  //     {
                  //       pattern: new RegExp(/^\d+(\.\d+)?$/),
                  //       message: "Only numerical values are allowed",
                  //     },
                  //   ]}
                  // >
                  //   <Input placeholder={`Enter ${filterType.value}`} />
                  // </Form.Item>
                  <Row span={24} gutter={8}>
                    <Col span={filterType.unitType ?  12 : 24} className="d-flex">
                      <Form.Item
                        name="gsmFilterValue"
                        className="removepadd"
                        rules={[
                          {
                            required: type === "rangeTypeSelect",
                            message: "This field is required",
                          },
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only numerical values are allowed",
                          },
                        ]}
                      >
                        <Input placeholder={`Enter ${filterType.value}`} />
                      </Form.Item>
                    </Col>
                    {filterType.unitType && (
                      <Col span={12} className="d-flex" >
                    <Form.Item
                    name="unitSelect"
                    className=""
                    rules={[
                      {
                        required: type === "unitSelect",
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Select
                        suffixIcon={<DownArrowDraw />}
                        // onChange={(e) => {
                        //   console.log("Event", e);
                        //   setGsmFilterType(e);
                        // }}
                        className={filterType.value}
                        placeholder="Select Unit"
                      >
                        { filterType.unitType == 'length' ?  unitData.units_management.length.data.map((item) => (
                          <Option key={item}>{item}</Option>
                        )) : filterType.unitType == 'weight' ? unitData.units_management.weight.data.map((item) => (
                          <Option key={item}>{item}</Option> )) : unitData.units_management.currency.data.map((item) => (
                            <Option key={item}>{item}</Option>))}
                      </Select>
                  </Form.Item>
                      </Col>
                    )}
                  </Row>
                )}
              </Form>
            </HaberForm>
          );
        case "input":
      return (
        <HaberForm className="filterForm filterRanged">
          <h6 className="filterTitle">
            {/* <Button className="backfilter" onClick={backFilter}>
              <span></span>
            </Button>{" "} */}
            Filter by {filterType.name}
          </h6>
          <Form
            form={jobCardForm}
            name="basic"
            autoComplete="off"
            className="haberLogin"
            onFieldsChange={onFieldsChange}
          >
            <Form.Item
              name="gsmFilterValue"
              className="removepadd"
              rules={[
                {
                  required: type === "input",
                  message: "This field is required",
                },
                {
                  pattern: new RegExp(/^[1-9]\d*$/),
                  message: "Only positive numerical values are allowed",
                },
              ]}
            >
              <Input
                placeholder={`Enter ${filterType.value}`}
                style={{ paddingLeft: "10px !important" }}
              />
            </Form.Item>
          </Form>
        </HaberForm>
      );
      default:
        return <></>;
    }
  };

  const handleDateSelect = (ranges) => {
    console.log("Filter type in filter", filterType, ranges);
    setDateSelectionRange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
      key: "selection",
    });
    const newFilter = {
      type: filterType.value,
      start_date: moment(ranges.selection.startDate).format("YYYY-MM-DD"),
      end_date: moment(ranges.selection.endDate).format("YYYY-MM-DD"),
    };
    if (dateSelectionRange.startDate && dateSelectionRange.endDate) {
      setDisableFilter(false);
    } else setDisableFilter(true);
    setAppliedFiltersArray(newFilter);
  };

  const applyFilterHandler = () => {
        setFilterBtnDisable(false);
        setDisableFilter(true);
        if (
          filterType.type === "inputSelect" ||
          filterType.type === "equalInputSelect"
        ) {
          let minValue = parseFloat(filterForm.getFieldValue("gsmMin"));
          let maxValue = parseFloat(filterForm.getFieldValue("gsmMax"));
          let thresholdValue = parseFloat(
            filterForm.getFieldValue("gsmFilterValue")
          );
          switch (filterType.value) {
            case "gsm":
              const gsmFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
            operator:selectedGsmOptions.current,

                ...(selectedGsmOptions.current === "in_range" && { min_gsm: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_gsm: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { gsm: thresholdValue }),
              };
              props.applyFilter(gsmFilter);
              setAppliedFiltersArray(gsmFilter);
              break;
            case "min_gsm":
              const minGsmFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_gsm_range: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_gsm_range: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { min_gsm: thresholdValue }),
              };
              props.applyFilter(minGsmFilter);
              setAppliedFiltersArray(minGsmFilter);
              break;
            case "max_gsm":
              const maxGsmFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { max_gsm_start: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_gsm_end: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { max_gsm: thresholdValue }),
              };
              props.applyFilter(maxGsmFilter);
              setAppliedFiltersArray(maxGsmFilter);
              break;
            case "burst_factor":
              const bfFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,

                ...(selectedGsmOptions.current === "in_range" && { min_burst_factor: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_burst_factor: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  burst_factor: thresholdValue,
                }),
              };
              props.applyFilter(bfFilter);
              setAppliedFiltersArray(bfFilter);
              break;
            case "width":
              const widthFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_width: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_width: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { width: thresholdValue }),
              };
              props.applyFilter(widthFilter);
              setAppliedFiltersArray(widthFilter);
              break;
            case "utilization":
              const utilizationFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_utilization: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_utilization: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  utilization: thresholdValue,
                }),
              };
              props.applyFilter(utilizationFilter);
              setAppliedFiltersArray(utilizationFilter);
              break;
            case "min_deckle_width":
              const minDeckleWidthFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_deckle_width: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_deckle_width: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  deckle_width: thresholdValue,
                }),
              };
              props.applyFilter(minDeckleWidthFilter);
              setAppliedFiltersArray(minDeckleWidthFilter);
              break;
            case "max_deckle_width":
              const maxDeckleWidthFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_deckle_width: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_deckle_width: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  deckle_width: thresholdValue,
                }),
              };
              props.applyFilter(maxDeckleWidthFilter);
              setAppliedFiltersArray(maxDeckleWidthFilter);
              break;
            case "production_capacity":
              const prodCapacityFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && {
                  min_production_capacity: minValue,
                }),
                ...(selectedGsmOptions.current === "in_range" && {
                  max_production_capacity: maxValue,
                }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  production_capacity: thresholdValue,
                }),
              };
              props.applyFilter(prodCapacityFilter);
              setAppliedFiltersArray(prodCapacityFilter);
              break;
            case "maximum_waste":
              const maxWasteFilter = {
                type: filterType.value,
                //  operator:selectedGsmOptions.current,
                operator:selectedGsmOptions.current,

                ...(selectedGsmOptions.current === "in_range" && {
                  min_maximum_waste: minValue,
                }),
                ...(selectedGsmOptions.current === "in_range" && {
                  max_maximum_waste: maxValue,
                }),
                ...(selectedGsmOptions.current !== "in_range" && {
                  maximum_waste: thresholdValue,
                }),
              };
              props.applyFilter(maxWasteFilter);
              setAppliedFiltersArray(maxWasteFilter);
              break;
            case "bulk":
              const bulkFilter = {
                type: filterType.value,
                 operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_bulk: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_bulk: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { bulk: thresholdValue }),
              };
              props.applyFilter(bulkFilter);
              setAppliedFiltersArray(bulkFilter);
              break;
            case "price":
              const priceFilter = {
                type: filterType.value,
                 operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_price: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_price: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { price: thresholdValue }),
              };
              props.applyFilter(priceFilter);
              setAppliedFiltersArray(priceFilter);
              break;
            case "reel_od":
              const reel_odFilter = {
                type: filterType.value,
                 operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_reel_od: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_reel_od: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { reel_od: thresholdValue }),
              };
              props.applyFilter(reel_odFilter);
              setAppliedFiltersArray(reel_odFilter);
              break;
            case "jcNo":
              const jcNoFilter = {
                type: filterType.value,
                 operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_reel_od: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_reel_od: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { jcNo: thresholdValue }),
              };
              props.applyFilter(jcNoFilter);
              setAppliedFiltersArray(jcNoFilter);
              break;
            case "core_id":
              const core_idFilter = {
                type: filterType.value,
                 operator:selectedGsmOptions.current,
                ...(selectedGsmOptions.current === "in_range" && { min_core_id: minValue }),
                ...(selectedGsmOptions.current === "in_range" && { max_core_id: maxValue }),
                ...(selectedGsmOptions.current !== "in_range" && { core_id: thresholdValue }),
              };
              props.applyFilter(core_idFilter);
              setAppliedFiltersArray(core_idFilter);
              break;
          }
          closeFilterDetails();
          setShowFilterOptions(false);
          filterForm.resetFields();
          sizeFilterForm.resetFields();
          jobCardForm.resetFields();
        } else if (filterType.type === "rangeTypeSelect") {
          let minValue = parseFloat(sizeFilterForm.getFieldValue("gsmMin"));
          let maxValue = parseFloat(sizeFilterForm.getFieldValue("gsmMax"));
          let thresholdValue = parseFloat(
            sizeFilterForm.getFieldValue("gsmFilterValue")
          );
          // let sizeType = sizeFilterForm.getFieldValue("sizeType");
          let sizeType;
          if(orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel"){
            sizeType = "width";
          } else{
            sizeType = sizeFilterForm.getFieldValue("sizeType");
          }
          const sizeFilter = {
            type: filterType.value,
            // operator: (orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") ? gsmFilterOptions[0]?.value : gsmFilterType,
            //  operator:selectedGsmOptions.current,
            operator:selectedGsmOptions.current,

            size_type: sizeType,
            ...(selectedGsmOptions.current === "in_range" && { min_size: minValue }),
            ...(selectedGsmOptions.current === "in_range" && { max_size: maxValue }),
            ...(((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { size: thresholdValue }),
            ...(filterType.unitType && selectedGsmOptions.current === "in_range" && { units : {min_size : sizeFilterForm.getFieldValue("unitSelect"),
              max_size : sizeFilterForm.getFieldValue("unitSelect")} }),
            ...(filterType.unitType && ((orderTypesData?.length == 1 && orderTypesData[0]?.name == "reel") || selectedGsmOptions.current !== "in_range") && { units : {size : sizeFilterForm.getFieldValue("unitSelect")} }),
          };      
          props.applyFilter(sizeFilter);
          setAppliedFiltersArray(sizeFilter);
          closeFilterDetails();
          setShowFilterOptions(false);
          filterForm.resetFields();
          sizeFilterForm.resetFields();
          jobCardForm.resetFields();
        } else if (filterType.type === "input") {
          let thresholdValue = parseInt(
            jobCardForm.getFieldValue("gsmFilterValue")
          );
          const jobCardFilter = {
            type: filterType.value,
            jobcard: thresholdValue,
          };
          props.applyFilter(jobCardFilter);
          setAppliedFiltersArray(jobCardFilter);
          closeFilterDetails();
          setShowFilterOptions(false);
          filterForm.resetFields();
          sizeFilterForm.resetFields();
          jobCardForm.resetFields();
        } else {
          if (appliedFiltersArray) {
            setSelectedGrade();
            setFilterBtnDisable(false);
            setDisableFilter(true);
            props.applyFilter(appliedFiltersArray);
            closeFilterDetails();
            setShowFilterOptions(false);
            setSelectedGradeQualtites([]);
            setCheckAllQualities(false);
            setSelectedQualities([]);
            setIndeterminate(false);
            setSearchedGrades(grades);
            setSearchedQualties(qualities);
            setShowQualities(false);
          }
        }
        setSelectedStates([]);
        setSelectedOption([]);
  };

  const closeFilterDetails = () => {
    // filterForm.resetFields();
    // sizeFilterForm.resetFields();
    // jobCardForm.resetFields();
    setGsmFilterType();
       selectedGsmOptions.current = 'equal_to';

    // setFilterType();
  };

  const showFilterDropDown = async () => {
    await window.addEventListener('click', handleMouseMove);
    setShowFilterOptions(!showFilterOptions);
    // setFilterType(props.filterType);
    
  };

  const backFilter = () => {
    // setFilterType();
    // setShowFilterOptions(true);
    // setFilterBtnDisable(false);
    // setDisableFilter(true);
    // setSelectedStates([]);
    // setSelectedOption([]);
  };

  const clearHandler = () => {
    setFilterBtnDisable(false);
    closeFilterDetails();
    setShowFilterOptions(false);
    setDisableFilter(true);
    setQualities([]);
    setShowQualities(false);
    setSelectedGrade();
    setSelectedQualities([]);
    clearFilters();
    setAppliedFiltersArray();
    filterForm.resetFields();
    sizeFilterForm.resetFields();
    setSelectedGradeQualtites([]);
    setCheckAllQualities(false);
    setSelectedQualities([]);
    jobCardForm.resetFields();
    setIndeterminate(false);
  };

  const clearFilters = () => {
    setIndeterminate(false);
    setSelectedStates([]);
    setAppliedFiltersArray([]);
    setSelectedGradeQualtites([]);
  };

  return filterType ? (
    <SearchBarHeader style={{}}>
      <div
        ref={filterRef}
        className="filterParent"
        style={{ maxWidth: "382Px" }}
      >
        <Button
          className="filterBtn"
          onClick={showFilterDropDown}
          disabled={filterBtnDisable}
          style = {{minWidth : "0px",padding: props.buttonType == "deckleOrders" ? "" : "0px 2px" ,marginRight : props.showBulkOrderUpdate ? "20px" : '',marginTop: props.showBulkOrderUpdate ?"5px" :'',border: props.showBulkOrderUpdate ?  "1px solid #605E5C" :"",
          borderRadius: props.showBulkOrderUpdate ?"8px" :"",width: props.showBulkOrderUpdate && props.buttonType != "deckleOrders" ? "124px":"", height: props.showBulkOrderUpdate ?"36px":""}}
        >
          <Iconmoon icon="filter" size={15} color="#605E5C" />
          {props.filterType.name}
        </Button> 
        {showFilterOptions && mousePos === "left" && (
          <FilterComp
            style={{ width: "minContent", right: "auto" }}
            visible={filterType}
            className={`filterDetailsModal filterTypeSelect ${
              filterType.value
            } ${filterType ? "visibleTrue" : ""}`}
            title={
              <FilteredGrid>
                <div className="filterHeader">
                  {/* <button
                  className="filterBackBtn"
                  onClick={() => {
                    closeFilterDetails();
                    showFilterDropDown();
                  }}
                >
                  B
                </button> */}
                  {filterType.label}
                </div>
              </FilteredGrid>
            }
            onCancel={closeFilterDetails}
          >
            {renderSwitch(filterType.type)}
            <div className="ant-modal-footer-section filterBtmClick">
              <Button
                key="back"
                className="themeBtn-plane"
                onClick={clearHandler}
              >
                <Iconmoon icon="wrong" size={13} color="#ea655b" /> Clear
              </Button>
              <Button
                key="submit"
                className="themeBtn"
                onClick={() => applyFilterHandler()}
                disabled={disableFilter}
              >
                <Iconmoon icon="correct" size={13} color="#ffffff" /> Filter
              </Button>
            </div>
          </FilterComp>
        )}
         {showFilterOptions && mousePos === "right" && (
          <FilterComp
            style={{ width: "minContent", left: "auto" }}
            visible={filterType}
            className={`filterDetailsModal filterTypeSelect ${
              filterType.value
            } ${filterType ? "visibleTrue" : ""}`}
            title={
              <FilteredGrid>
                <div className="filterHeader">
                  {/* <button
                  className="filterBackBtn"
                  onClick={() => {
                    closeFilterDetails();
                    showFilterDropDown();
                  }}
                >
                  B
                </button> */}
                  {filterType.label}
                </div>
              </FilteredGrid>
            }
            onCancel={closeFilterDetails}
          >
            {renderSwitch(filterType.type)}
            <div className="ant-modal-footer-section filterBtmClick">
              <Button
                key="back"
                className="themeBtn-plane"
                onClick={clearHandler}
              >
                <Iconmoon icon="wrong" size={13} color="#ea655b" /> Clear
              </Button>
              <Button
                key="submit"
                className="themeBtn"
                onClick={() => applyFilterHandler()}
                disabled={disableFilter}
              >
                <Iconmoon icon="correct" size={13} color="#ffffff" /> Filter
              </Button>
            </div>
          </FilterComp>
        )}
      </div>
    </SearchBarHeader>
  ) : null;
};

export default OrderFilter;
